import { storeBadges, trustItems } from "./data.js";
import HeroImg from "../../assets/heroImg.png"
import JewelleryLogo from "../../assets/jewellery.png"
import TripLogo from "../../assets/travelApp.png"
import PlaneLogo from "../../assets/plane.png"
import PhoneLogo from "../../assets/iPhone_17_pro_max.avif"
import LaptopLogo from "../../assets/macbookAirM3.webp"
import BikeLogo from "../../assets/bike1.png"
import CameraLogo from "../../assets/camera.png"
import LuxuryLogo from "../../assets/luxury.png"
import PS5Logo from "../../assets/ps5.png"
import DysonLogo from "../../assets/dyson.png"
import EVsLogo from "../../assets/EVs.png"
import underline from "../../assets/underline.png"

// ── floating goal items that orbit the phone image ──────────────────────────
const orbitItems = [
  { label: "Jewellery", imgSrc: JewelleryLogo, pos: "top-[0%] left-[28%] lg:top-[1.5%] lg:left-[30%]" },
  { label: "Trip", imgSrc: PlaneLogo, pos: "top-[0%] left-[50%] lg:top-[1%] lg:left-[50%]" },
  { label: "Phone", imgSrc: PhoneLogo, pos: "top-[8%] right-[10%] lg:top-[6%] lg:right-[18%]" },
  { label: "Laptop", imgSrc: LaptopLogo, pos: "top-[10%] left-[8%] lg:top-[10%] lg:left-[15%]" },
  { label: "Bike", imgSrc: BikeLogo, pos: "top-[25%] right-[0%] lg:top-[20%] lg:right-[7%]" },
  { label: "Camera", imgSrc: CameraLogo, pos: "bottom-[58%] left-[0%] lg:top-[24%] lg:left-[7%]" },
  { label: "Luxury", imgSrc: LuxuryLogo, pos: "bottom-[39%] right-[0%] lg:top-[35%] lg:right-[4%]" },
  { label: "PS5", imgSrc: PS5Logo, pos: "bottom-[40%] left-[1%] lg:top-[39%] lg:left-[4%]" },
  { label: "EV", imgSrc: EVsLogo, pos: "bottom-[22%] right-[6%] lg:bottom-[36%] lg:right-[6%]" },
  { label: "Dyson", imgSrc: DysonLogo, pos: "bottom-[22%] left-[6%] lg:bottom-[33%] lg:left-[9%]" },
];

const trustCards = [
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className="w-8 h-8 text-[#4C42FD]">
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
        <circle cx="9" cy="7" r="4" />
        <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
        <path d="M16 3.13a4 4 0 0 1 0 7.75" />
        <path d="M9 13.5 l1.5 1.5 L13 12" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
    title: "No burden",
    sub: "after spending",
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className="w-8 h-8 text-[#4C42FD]">
        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
        <path d="m9 12 2 2 4-4" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
    title: "No debt trap",
    sub: "ever again",
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className="w-8 h-8 text-[#4C42FD]">
        <path d="M9 14 A5 5 0 1 0 9 4 A5 5 0 0 0 9 14" />
        <path d="m15.5 9.5 5 5" strokeLinecap="round" />
        <path d="M19 19 l-1.5-1.5" strokeLinecap="round" />
        <path d="M6 7h.01M9 7h.01" />
        <text x="7" y="11" fontSize="4" fill="currentColor" stroke="none">%</text>
      </svg>
    ),
    title: "Best",
    sub: "discounted deal",
  },
];



function StoreButtons() {
  return (
    <div className="flex flex-wrap items-center gap-3">
      {storeBadges.map((badge) => (
        <a
          key={badge.alt}
          href={badge.href}
          target="_blank"
          rel="noreferrer"
          className="transition duration-300 md:hover:scale-105"
        >
          <img src={badge.imgUrl} alt={badge.alt} className="h-12 w-auto sm:h-14" />
        </a>
      ))}
    </div>
  );
}

export default function Hero() {
  return (
    <>
      {/* ── HERO SECTION ─────────────────────────────────────────────────── */}
      <section className="relative overflow-hidden bg-[#FFFFFF]">
        {/* subtle grid dots */}
        <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(rgba(26,86,219,0.07)_1px,transparent_1px)] [background-size:32px_32px]" style={{ willChange: 'transform', transform: 'translateZ(0)' }} />

        <div className="relative font-montserrat mx-auto grid min-h-[calc(100vh-72px)] max-w-7xl items-center gap-8 px-4 py-16 sm:px-6 lg:grid-cols-2 lg:px-8 lg:pb-24 lg:pt-12">

          {/* LEFT ── copy */}
          <div className="flex flex-col">
            <h1 className="text-[2.2rem] font-black leading-[1.08] tracking-[-0.03em] text-[#111827] sm:text-[2.8rem] lg:text-[3.3rem] font-montserrat">
    Break your travel &
    <br />
    purchase expenses
    <br />
    <span className="text-[#4C42FD] relative inline-block font-montserrat pb-4">
      into small amounts
      <img
        src={underline}
        alt=""
        className="absolute left-0 -bottom-1 w-32 sm:w-40"
      />
    </span>
  </h1>
            {/* Returns + Discount inline cards */}
            <div className="mt-6 flex flex-wrap gap-3">
              <div className="flex items-center gap-3 rounded-2xl border border-[#e0e7ff] bg-[#f6f4ff] px-5 py-3">
                <span className="text-2xl font-black text-[#4C42FD] font-montserrat leading-none">6.35%</span>
                <div>
                  <p className="text-xs font-bold text-[#4C42FD] font-montserrat leading-tight">Returns on RD</p>
                  <p className="text-[10px] text-[#6b7280] font-montserrat">Guaranteed</p>
                </div>
              </div>
              <div className="flex items-center gap-3 rounded-2xl border border-[#d1fae5] bg-[#f0fdf4] px-5 py-3">
                <span className="text-2xl font-black text-[#16a34a] font-montserrat leading-none">+10%</span>
                <div>
                  <p className="text-xs font-bold text-[#16a34a] font-montserrat leading-tight">Extra Discount</p>
                  <p className="text-[10px] text-[#6b7280] font-montserrat">On any app or store</p>
                </div>
              </div>
            </div>

            <p className="mt-8 max-w-xl text-lg leading-relaxed text-[#4B5563] sm:text-xl font-montserrat">
              It’s not about affordability — it’s about
              <span className="font-semibold text-[#111827] font-montserrat">
                {" "}smartly managing expenses
              </span>{" "}
              so your
              <span className="font-semibold text-[#4C42FD] font-montserrat">
                {" "}daily life stays smooth
              </span>{" "}
              even after spending on travel and purchases.
            </p>




            {/* Trust cards — desktop horizontal, mobile 3-col grid */}
            <div className="mt-8 grid grid-cols-3 gap-3 sm:flex sm:flex-wrap sm:gap-4">
              {trustCards.map((c) => (
                <div
                  key={c.title}
                  className="flex flex-col items-center gap-2 rounded-2xl border border-[#c8dcf8] bg-white px-4 py-4 text-center shadow-sm sm:flex-row sm:text-left"
                >
                  <div className="shrink-0 rounded-full bg-[#eaf1fd] p-2">{c.icon}</div>
                  <div>
                    <div className="font-montserrat text-sm font-bold text-[#0d1f3c]">{c.title}</div>
                    <div className="font-montserrat text-xs text-[#4C42FD]">{c.sub}</div>
                  </div>
                </div>
              ))}
            </div>

            {/* <div className="mt-8">
              <StoreButtons />
            </div> */}

            {/* trust pills */}
            {/* <div className="mt-6 flex flex-wrap gap-4">
              {trustItems.map((item) => (
                <div
                  key={item}
                  className="flex items-center gap-2 text-sm font-semibold text-[#3d5a80] font-montserrat"
                >
                  <span className="text-[#1a56db]">✓</span>
                  {item}
                </div>
              ))}
            </div> */}
          </div>

          {/* RIGHT ── hero image with orbiting items */}
          <div className="relative justify-center lg:justify-end">
            <div className="relative w-full max-w-[540px] aspect-[9/10]">

              {/* glow blob behind image */}
              <div className="absolute inset-0 rounded-full bg-[#DBD9F6]/40 blur-3xl scale-75" style={{ willChange: 'transform', backfaceVisibility: 'hidden', transform: 'translateZ(0) scale(0.75)' }} />

              {/* ── PLACEHOLDER for hero woman image ── */}
              <div className="absolute inset-[8%] z-10 bottom-5 flex items-end justify-center">
                <div className="w-full h-full rounded-3xl  flex flex-col items-center justify-center gap-3">
                  <img src={HeroImg} alt="" className="w-full h-full object-cover" />
                </div>
              </div>

              {/* orbiting product bubbles — hidden on mobile, shown lg+ */}
              {orbitItems.map((item) => (
                <div
                  key={item.label}
                  className={`absolute md:h-16 md:w-16 h-14 w-14 flex flex-col items-center rounded-full bg-white z-10 shadow-md shadow-[#93bef5]/30 ${item.pos}`}
                >
                  <div className="flex h-8 w-8 md:h-10 md:w-10 pt-2 items-center justify-center text-2xl">
                    {item.imgSrc && <img src={item.imgSrc} alt={item.label} className="h-full w-full object-contain" />}
                  </div>
                  <span className="text-[9px] font-semibold text-[#0d1f3c] font-montserrat">{item.label}</span>
                </div>
              ))}

              {/* dashed orbit ring */}
              <svg
                className="absolute inset-0 w-full h-full block pointer-events-none"
                viewBox="0 10 540 750"
                fill="none"
              >
                <ellipse
                  cx="270" cy="320"
                  rx="280" ry="270"
                  stroke="#93bef5"
                  strokeWidth="1.5"
                  strokeDasharray="6 8"
                />
              </svg>
            </div>
          </div>
        </div >
      </section >

    </>
  );
}